import React, { useState } from "react";
import { FaFilePdf } from "react-icons/fa";
import works from "../../assets/data/works-list.json";
import SectionHeading from "../SectionHeading";

const tabs = [
  { key: "completed", label: "Completed" },
  { key: "inProgress", label: "In Progress" },
];

const INITIAL_ROWS = 6;

const formatValue = (lakh) => `₹${lakh.toLocaleString("en-IN")} Lakh`;

// Full list of recent works from the company catalogue. Rendered as stacked
// cards (not a wide table) so it reads well on phones.
function WorksList() {
  const [active, setActive] = useState("completed");
  const [expanded, setExpanded] = useState(false);
  const rows = expanded ? works[active] : works[active].slice(0, INITIAL_ROWS);
  const hidden = works[active].length - rows.length;

  return (
    <section className="bg-white py-16 sm:py-24 border-t border-gray-100">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="Track Record"
          title="Recent Works"
          subtitle="Work completed and in progress for government bodies and leading private companies."
        />

        <div role="tablist" aria-label="Work status" className="mb-6 flex justify-center gap-2">
          {tabs.map(({ key, label }) => (
            <button
              key={key}
              type="button"
              role="tab"
              id={`works-tab-${key}`}
              aria-selected={active === key}
              aria-controls="works-panel"
              onClick={() => {
                setActive(key);
                setExpanded(false);
              }}
              className={`inline-flex items-center gap-2 rounded-full border-2 px-5 py-2 text-sm font-semibold transition-colors ${
                active === key
                  ? "border-brand-navy bg-brand-navy text-white"
                  : "border-gray-200 bg-white text-gray-700 hover:border-brand-yellow hover:text-brand-navy"
              }`}
            >
              {label}
              <span
                className={`rounded-full px-2 py-0.5 text-xs ${
                  active === key ? "bg-brand-yellow text-brand-navy" : "bg-gray-100 text-gray-600"
                }`}
              >
                {works[key].length}
              </span>
            </button>
          ))}
        </div>

        <ul id="works-panel" role="tabpanel" aria-labelledby={`works-tab-${active}`} className="space-y-3">
          {rows.map((row) => (
            <li
              key={`${row.work}-${row.year}`}
              className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6 rounded-2xl border border-gray-200 border-l-4 border-l-brand-yellow bg-white p-4 sm:p-5 shadow-sm"
            >
              <div className="min-w-0 flex-1">
                <p className="font-semibold text-gray-900 leading-snug">{row.work}</p>
                <p className="mt-1 text-sm font-medium text-brand-navy-light">{row.client}</p>
              </div>
              <div className="flex shrink-0 items-center gap-3 sm:flex-col sm:items-end sm:gap-1">
                <span className="rounded-full bg-gray-100 px-3 py-1 text-xs font-semibold text-gray-700">{row.year}</span>
                <span className="text-sm font-bold text-brand-navy">{formatValue(row.valueLakh)}</span>
              </div>
            </li>
          ))}
        </ul>

        {hidden > 0 && (
          <div className="mt-5 text-center">
            <button
              type="button"
              onClick={() => setExpanded(true)}
              className="text-sm font-bold text-brand-navy underline decoration-brand-yellow decoration-2 underline-offset-4 hover:text-brand-navy-light py-2"
            >
              Show all {works[active].length} works
            </button>
          </div>
        )}

        <div className="mt-10 text-center">
          <a
            href={`${process.env.PUBLIC_URL}/RCB-Catalogue-2025.pdf`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full bg-brand-navy px-7 py-3.5 font-bold text-white shadow-lg transition-all hover:bg-brand-navy-light hover:-translate-y-0.5"
          >
            <FaFilePdf aria-hidden="true" /> View Full Catalogue (PDF, 3.3 MB)
          </a>
        </div>
      </div>
    </section>
  );
}

export default WorksList;
